export default __webpack_public_path__ + "static/media/register-success.b3875027.png";